import "slick-carousel";

export const fullHeightSlider = function ($block) {
  $(".block-full-height-slider").not(".slick-initialized").slick({
    arrows: false,
    fade: true,
    autoplay: false, // true
    dots: true,
    dotsClass: "slide__dots",
  });
};
